import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { EditorSession } from '../EditorSession';
import { Widget, WidgetBaseProps } from '../workspace/widgets/WidgetInterface';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { HasId, PropertyFacade } from './PropertyFacade';

export type PropertyStripLayout<T extends HasId> = (
    dispatch: CommandDispatcher,
    session: EditorSession,
    objects: ObjectManager,
    widgets: WidgetManager,
    targets: PropertyFacade<T>,
) =>
    readonly Widget<WidgetBaseProps>[];

export const PropertyStripLayout = <T extends HasId>(psl: PropertyStripLayout<T>) => psl;
